import React from 'react';
import './Features.css';
import previewVideo from './preview.mp4'; // Stelle sicher, dass sich die Datei im richtigen Verzeichnis befindet

const Features = () => {
  return (
    <div className="features-component" id="features">
      <div className="features-left">
        <video
          src={previewVideo}
          className="features-lock"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
      <div className="features-right">
        <h2>Unmatched Security <br />with many Features.</h2>
        <p>
          Eagle Script offers <span style={{color: "#CAF881"}}>enhanced security measures.</span> Stay completely under the radar while enjoying the great advantages of this hardware Rust script. The macro features <span style={{color: "#CAF881"}}>all weapons & attachments</span> — even minigun!
        </p>
      </div>
    </div>
  );
};

export default Features;
